module.exports = __webpack_public_path__ + "img/net_banking.caea407f.svg";